// Reactive "what does this choice get you" panel. Renders the selected
// candidate's projection; falls back to the workflow's static impact summary
// when there's no decision-support candidate for this workflow.

import {FC} from "react";
import type {DecisionCandidate} from "./decisionSupport";
import {Sparkline} from "./Sparkline";

interface ProjectedImpactPanelProps {
    candidate: DecisionCandidate | null;
    accent: string;
}

export const ProjectedImpactPanel: FC<ProjectedImpactPanelProps> = ({
    candidate,
    accent
}) => {
    if (!candidate) {
        return null;
    }

    const {projection} = candidate;

    return (
        <div className="pi-projected-impact">
            <div className="pi-projected-impact__text">
                <span className="pi-projected-impact__headline">
                    {projection.headline}
                </span>
                <span className="pi-projected-impact__value">{projection.value}</span>
                {projection.deltaLabel && (
                    <span className="pi-projected-impact__delta">
                        {projection.deltaLabel}
                    </span>
                )}
                {projection.secondary && (
                    <span className="pi-projected-impact__secondary">
                        {projection.secondary}
                    </span>
                )}
            </div>
            {projection.curve && projection.curve.length > 1 && (
                <div className="pi-projected-impact__chart">
                    <Sparkline points={projection.curve} stroke={accent} />
                </div>
            )}
        </div>
    );
};

export default ProjectedImpactPanel;
